import { WorklistPage } from "@/features/worklist/components/WorklistPage";
import {
    clinicianWorklistQueryOptions,
    incompleteDataDiariesQueryOptions,
    worklistConsentsQueryOptions,
} from "@/features/worklist/api/worklistQueryOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/worklist")({
    component: WorklistPage,
    loader: async ({ context }) => {
        await Promise.all([
            context.queryClient.ensureQueryData(clinicianWorklistQueryOptions()),
            context.queryClient.ensureQueryData(incompleteDataDiariesQueryOptions()),
            context.queryClient.ensureQueryData(worklistConsentsQueryOptions()),
        ]);
    },
});
